<template>
  <print v-if="isPrint" :form="form" />
  <div v-else>
    <div style="color: #7367f0; position: absolute; top: 0px; left: 13rem; height: 40px; padding: 1.5rem; box-sizing: content-box" class="flex items-center gap-2 cursor-pointer" @click="popupTip = true">
      <feather-icon icon="AlertCircleIcon" style="width: 16px" /> 작성 방법
    </div>
    <vs-popup :active.sync="popupTip" title="< 중대재해 발생 보고서 작성 방법 >">
      <div style="border: 1px solid #dedede" class="p-4">
        <ol style="padding-left: 16px; margin: 0px; list-style-type: decimal">
          <li>
            <b>사업장 개요</b>
          </li>
          <ul style="padding-left: 12px; margin: 0px; list-style-type: '- '">
            <li>근로자 수: 교육공무원, 지방공무원, 교육감소속근로자, 기간제 근로자 모두 포함</li>
          </ul>
          <li><b>재해자 인적사항</b></li>
          <ul style="padding-left: 12px; margin: 0px; list-style-type: '- '">
            <li>재해자 성명, 생년월일, 임용일자, 재해 정도 등을 기재함</li>
          </ul>
          <li><b>재해발생 내용 및 조치 현황</b></li>
          <ul style="padding-left: 12px; margin: 0px; list-style-type: '- '">
            <li>사고 발생 일시 및 장소 기재</li>
            <li>재해발생 형태</li>
            <ul style="padding-left: 6px; margin: 0px; list-style-type: ''">
              <li>① 떨어짐(높이가 있는 곳에서 사람이 떨어짐)</li>
              <li>② 넘어짐(사람이 미끄러지거나 넘어짐)</li>
              <li>③ 깔림(물체의 쓰러짐이나 뒤집힘)</li>
              <li>④ 부딪힘(물체에 부딪힘)</li>
              <li>⑤ 맞음(날아오거나 떨어진 물체에 맞음)</li>
              <li>⑥ 무너짐(건축물이나 쌓여진 물체가 무너짐)</li>
              <li>⑦ 끼임(기계설비에 끼이거나 감김)</li>
              <li>⑧ 절단, 베임, 찔림</li>
            </ul>
          </ul>
        </ol>
        <br />
        <ul style="padding-left: 16px; margin: 0px; list-style: disc">
          <li>
            <b>기인물: 재해를 초래하는 근원이 되었던 기계, 장치, 그 밖의 물건과 환경 (기계, 차량, 설비, 유해, 유해물 등)</b><br />✽ 사고 발생 설비: 사고 발생 공정과 설비의 최초 운전 및 설비에 대한 장비 보수 이력 또는 고장 이력, 사고 설비
            고장 부위의 파손 정도와 용량, 설계 및 운전 조건 등을 포함한 설비의 사양을 기재함<br />✽ 물질에 의한 사고인 경우: 물질의 화학명, 보유량, 상태 및 기타 물리·화학적 특성을 기재함
          </li>
          <li>
            <b>사고 발생 공정 및 작업 상황</b><br />- 사고 시 운전 상황 또는 작업 상황을 구체적으로 기재함<br />- 장치의 불량상태 및 고장 또는 점검·수리 등과 같은 사고 발생에 관계가 있다고 생각되는 원인에서 사고에 이르기까지의 경과와 사고의
            발생 또는 발견 시점부터 사고가 수습되기까지의 경과를 시간에 따라 상세하게 기재함
          </li>
          <li><b>사고원인</b><br />- 직접적인 원인이 되는 점화원 등을 기재하고 사고가 일어난 직접적인 동기를 기술함<br />- 안전작업 수칙 미준수, 설계 미흡 및 운전자의 운전 절차 미숙지 등 간접적인 원인을 포함하여 기재함</li>
        </ul>
      </div>
    </vs-popup>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" @selectField="selectField" />

    <!-- 보고자 및 수신자 -->
    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 보고자 및 수신자</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>문서번호</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputA_1" />
        </div>
        <div>
          <div>발신자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputA_2" />
        </div>
        <div>
          <div>수신자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputA_3" />
          <p class="pl-2">귀하</p>
        </div>
      </div>
    </div>

    <!-- 사업장 개요 -->
    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 사업장 개요</h5>
      <div class="writeGridContainer mt-4">
        <div>
          <div>사업장명</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input readonly v-else v-model="form.inputB_1" />
        </div>
        <div>
          <div>대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input readonly v-else v-model="form.inputB_2" />
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_3" />
        </div>
        <div>
          <div>근로자수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputB_5" />
        </div>
        <div>
          <div>업종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputB_6" />
        </div>
      </div>
    </div>

    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 도급, 용역, 위탁 등 계약의 경우 작성</h5>
      <!-- 원청 -->
      <div class="writeGridContainer mt-4">
        <div>
          <div>업체명(도급인)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>
          <field-selector :readonly="board.readonly" v-else v-model="form.inputC_1" @select="selectC" />
        </div>
        <div>
          <div>대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>
          <ml-input readonly v-else v-model="form.inputC_2" />
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_3 }}</p>
          <ml-input readonly v-else v-model="form.inputC_3" />
        </div>
        <div>
          <div>연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_4 }}</p>
          <ml-input readonly v-else v-model="form.inputC_4" />
        </div>
        <div>
          <div>근로자수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputC_5" />
        </div>
        <div>
          <div>업종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputC_6" />
        </div>
      </div>

      <!-- 수급인 -->
      <div class="writeGridContainer mt-12">
        <div>
          <div>업체명(수급인)</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_1 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputD_1" />
        </div>
        <div>
          <div>대표자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputD_2" />
        </div>
        <div>
          <div>소재지</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_3 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputD_3" />
        </div>
        <div>
          <div>연락처</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_4 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputD_4" />
        </div>
        <div>
          <div>근로자수</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_5 }}</p>
          <comma-input :readonly="board.readonly" v-else v-model="form.inputD_5" />
        </div>
        <div>
          <div>업종</div>
          <p v-if="isPrint" class="print-input">{{ form.inputD_6 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputD_6" />
        </div>
      </div>
      <div class="writeGridContainer mt-4">
        <div>
          <div>중대재해처벌법에 따른 중대산업재해 해당 여부</div>
          <div class="flex items-center gap-4">
            <vs-checkbox :checked="form.inputD_7 === '해당'" @change="checkForm($event, '해당')">해당</vs-checkbox>
            <vs-checkbox :checked="form.inputD_7 === '미해당'" @change="checkForm($event, '미해당')">미해당</vs-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- 재해자 인적사항 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해자 인적사항</h5>
          <vs-col v-if="!board.readonly" class="w-auto ml-auto">
            <vs-button class="mr-4" color="secondary" @click="handleClickPush('inputE_1')">항목추가</vs-button>
            <vs-button class="mr-4" color="secondary" type="border" @click="handleClickPop('inputE_1')">마지막항목 삭제</vs-button>
          </vs-col>
        </vs-col>
      </vs-row>
      <div class="mt-4 style-table">
        <div class="style-table-head">
          <div class="style-table-item">성명</div>
          <div class="style-table-item">생년월일</div>
          <div class="style-table-item">소속</div>
          <div class="style-table-item">직종</div>
          <div class="style-table-item">입사일자</div>
          <div class="style-table-item">동종경력</div>
          <div class="style-table-item">재해정도</div>
        </div>

        <div v-for="(item, item_i) in form.inputE_1" :key="item_i" class="style-table-body">
          <!-- 성명 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.name }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="item.name" class="w-full flex-1" />
          </div>

          <!-- 생년월일 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.rrn1 }}</p>
            <date-selector :readonly="board.readonly" v-else v-model="item.rrn1" class="w-full flex-1" />
          </div>

          <!-- 소속 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.group }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="item.group" class="w-full flex-1" />
          </div>

          <!-- 직종 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.typeOfWork }}</p>
            <ml-input :readonly="board.readonly" v-else v-model="item.typeOfWork" class="w-full flex-1" />
          </div>

          <!-- 입사일자 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.hireDate }}</p>
            <date-selector :readonly="board.readonly" v-else v-model="item.hireDate" class="w-full flex-1"></date-selector>
          </div>

          <!-- 동종경력 -->
          <div class="style-table-item">
            <p v-if="isPrint" class="print-input">{{ item.workYear }}년 {{ item.workMonth }}월</p>
            <div v-else style="display: flex; align-items: center">
              <ml-input :readonly="board.readonly" v-model="item.workYear" class="w-full flex-1" />
              <span class="mx-2">년</span>
              <ml-input :readonly="board.readonly" v-model="item.workMonth" class="w-full flex-1" />
              <span class="ml-2">월</span>
            </div>
          </div>

          <!-- 재해정도 -->
          <div class="style-table-item">
            <div v-if="isPrint" class="w-full"></div>
            <div v-else class="w-full">
              <div class="mb-2" style="display: flex; align-items: center">
                <vs-checkbox :disabled="board.readonly" v-model="item.사망">사망</vs-checkbox>
                <comma-input class="ml-auto" style="width: 60px" :readonly="board.readonly" v-model="item.사망수" />
                <span class="ml-2">명</span>
              </div>
              <div class="mb-2" style="display: flex; align-items: center">
                <vs-checkbox :disabled="board.readonly" v-model="item.부상">부상</vs-checkbox>
                <comma-input class="ml-auto" style="width: 60px" :readonly="board.readonly" v-model="item.부상수" />
                <span class="ml-2">명</span>
              </div>
              <div style="display: flex; align-items: center">
                <span>치료예상기간</span>
                <comma-input class="ml-auto" style="width: 60px" :readonly="board.readonly" v-model="item.치료예상기간" />
                <span class="ml-2">일</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 재해발생 내용 및 조치현황 -->
    <div class="mt-5">
      <vs-row class="my-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 재해발생 내용 및 조치현황</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer mt-4">
        <div>
          <div>재해일시</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_1 }}</p>
          <date-selector :readonly="board.readonly" v-else v-model="form.inputF_1" />
        </div>
        <div>
          <div>재해장소</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_2 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputF_2" />
        </div>
        <div>
          <div>발생형태</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_3 }}</p>
          <disaster-class-selector v-else v-model="form.inputF_3" :readonly="board.readonly" />
        </div>
        <div>
          <div>기인물</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_4 }}</p>
          <ml-input :readonly="board.readonly" v-else v-model="form.inputF_4" />
        </div>
        <div>
          <div>행정조치</div>
          <p v-if="isPrint" class="print-input">{{ form.inputF_5 }}</p>
          <vs-select :readonly="board.readonly" v-else v-model="form.inputF_5" autocomplete>
            <vs-select-item text="시정지시" value="시정지시" />
            <vs-select-item text="사용중지" value="사용중지" />
            <vs-select-item text="부분·전면작업중지" value="부분·전면작업중지" />
            <vs-select-item text="기타" value="기타" />
            <vs-select-item text="해당없음" value="해당없음" />
          </vs-select>
        </div>
      </div>
    </div>

    <!-- 사고경위 -->
    <div class="mt-8">
      <h5 class="mb-4"><i class="dot"></i> 사고경위</h5>
      <ml-textarea class="w-full" rows="5" v-model="form.inputG_1" :readonly="board.readonly" />
    </div>

    <!-- 조치 및 전망 -->
    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 조치 및 전망</h5>
      <ml-textarea class="w-full" rows="5" v-model="form.inputG_2" :readonly="board.readonly" />
    </div>

    <!-- 조사반 편성방법 -->
    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 조사반 편성방법</h5>
      <ml-textarea class="w-full" rows="5" v-model="form.inputG_3" :readonly="board.readonly" />
    </div>

    <!-- 기타 중요한 사항(재해 인지 경위 등) -->
    <div class="mt-5">
      <h5 class="mb-4"><i class="dot"></i> 기타 중요한 사항(재해 인지 경위 등)</h5>
      <ml-textarea class="w-full" rows="5" v-model="form.inputG_4" :readonly="board.readonly" />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :readonly="board.readonly" :is-print="isPrint"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import Print from "./Print.vue";
import CommaInput from "../../../../components/CommaInput.vue";

export default {
  components: {
    Print,
    FieldSelector,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    DisasterClassSelector,
    CommaInput,
  },
  props: {
    isPrint: Boolean,
    header: Object,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      popupTip: false,

      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "교육서비스업",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",

        inputD_1: "",
        inputD_2: "",
        inputD_3: "",
        inputD_4: "",
        inputD_5: "",
        inputD_6: "",
        inputD_7: "",

        inputE_1: [],

        inputF_1: "",
        inputF_2: "",
        inputF_3: "",
        inputF_4: "",
        inputF_5: "",

        inputG_1: "",
        inputG_2: "",
        inputG_3: "",
        inputG_4: "",

        fileList: [],
      },
    };
  },
  methods: {
    selectField(data) {
      this.form.inputB_1 = data.field_name;
      this.form.inputB_2 = data.director_name;
      this.form.inputB_3 = data.address;
    },
    selectC(data) {
      this.form.inputC_2 = data.director_name;
      this.form.inputC_3 = data.address;
      this.form.inputC_4 = data.phone;
    },
    handleClickPush(form_key) {
      if (form_key === "inputE_1") {
        this.form[form_key].push({
          name: "",
          rrn1: "",
          rrn2: "",
          group: "",
          typeOfWork: "",
          hireDate: "",
          workYear: "",
          workMonth: "",
          사망: false,
          사망수: "",
          부상: false,
          부상수: "",
          치료예상기간: "",
        });
      }
    },
    handleClickPop(form_key) {
      this.form[form_key].pop();
    },
    checkForm(value, text) {
      this.form.inputD_7 = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>

<!-- table -->
<style scoped lang="scss">
.style-table {
  border-left: 1px solid #cdcdcd;
  border-top: 1px solid #cdcdcd;
}
.style-table-item {
  padding: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
}
.style-table-head,
.style-table-body {
  display: grid;
  grid-template-columns: 151fr 151fr 151fr 151fr 151fr 151fr 179fr;
}
.style-table-head {
  .style-table-item {
    height: 50px;
    background-color: #f9f9f9;
  }
}
</style>
